import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './FilterListContainer.module.scss';

const FilterListContainer: FC<Props> = ({
  children,
  classNameModifier,
}) => (
  <ul className={getClassName(s, 'root', classNameModifier)}>
    {children}
  </ul>
);

type Props = {
  classNameModifier?: string;
};

export default FilterListContainer;
